import type { ComponentProps } from "react";
import { Toaster as Sonner } from "sonner";

type AlertCalloutToasterProps = ComponentProps<typeof Sonner>;

export const AlertCalloutToaster = ({ ...props }: AlertCalloutToasterProps) => {
  return (
    <Sonner
      data-styled="false"
      className="toaster group"
      position="bottom-left"
      toastOptions={{
        classNames: {
          toast: "group toast p-0 rounded-md shadow-none border-none",
        },
      }}
      {...props}
    />
  );
};
